import { AttachFile } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { CreateConversationPayload } from "@rms-types/modules/conversation/dto";
import { useState } from "react";

import { FileUploaderWrapper, ReactHookForm, ReactHookFormProps, schemas } from "@/components";
import { conversationEndpoint } from "@/constants";

export interface CreateConversationFormValues {
  to: number[];
  cc: number[];
  content: string;
  subject: string;
  attachment_group_id?: number | undefined;
}

export interface ConversationCreateFormProps
  extends Pick<
    ReactHookFormProps<CreateConversationFormValues, CreateConversationFormValues, CreateConversationPayload>,
    "data" | "loading" | "onSubmit"
  > {
  hideTo?: boolean;
  modifySubmissionValues?(values: CreateConversationFormValues): CreateConversationPayload;
}

export function ConversationCreateForm({
  hideTo = false,
  onSubmit,
  modifySubmissionValues,
  ...props
}: ConversationCreateFormProps) {
  const [showCC, setShowCC] = useState(false);

  return (
    <ReactHookForm<CreateConversationFormValues, CreateConversationFormValues, CreateConversationPayload>
      view="modal"
      onSubmit={onSubmit}
      submitText="Send"
      modifySubmissionValues={modifySubmissionValues}
      formSchema={[
        ...(!hideTo
          ? [
              schemas.accountAsyncMultiSelect<CreateConversationFormValues>({
                name: "to",
                label: "To",
                endpoint: conversationEndpoint.conversationRecipients,
                xs: 12,
                inputSlotProps: {
                  endAdornment: !showCC && (
                    <Stack direction="row" alignItems="center" spacing={1}>
                      {!showCC && (
                        <Typography color="primary" sx={{ cursor: "pointer" }} onClick={() => setShowCC(true)}>
                          CC
                        </Typography>
                      )}
                    </Stack>
                  ),
                },
                getFilteredOptions: (data, values) => data.filter((option) => !values.cc?.includes(option.id)),
              }),
              schemas.accountAsyncMultiSelect<CreateConversationFormValues>({
                name: "cc",
                label: "CC",
                endpoint: conversationEndpoint.conversationRecipients,
                xs: 12,
                getHidden: () => !showCC,
                getFilteredOptions: (data, values) => data.filter((option) => !values.to?.includes(option.id)),
              }),
            ]
          : []),

        {
          type: "text",
          name: "subject",
          label: "Subject",
          xs: 12,
        },
        {
          type: "lexical",
          name: "content",
          placeholder: "Enter your message here",
          required: true,
        },
        {
          type: "file",
          name: "attachment_group_id",
          renderDropzone: (options) => (
            <FileUploaderWrapper dropzoneOptions={options} sx={{ width: "fit-content" }}>
              <IconButton>
                <AttachFile />
              </IconButton>
            </FileUploaderWrapper>
          ),
        },
      ]}
      {...props}
    />
  );
}
